import { createFileRoute } from "@tanstack/react-router";
import { WebhookDetail } from "../../../features/settings/webhook-detail";

export const Route = createFileRoute("/_authed/$org/settings/webhooks/$name")({ component: WebhookPage });

function WebhookPage() {
  const { org, name } = Route.useParams();
  return <WebhookDetail org={org} name={name} />;
}
